import { Link } from 'react-router-dom';
import MangaCard from '@/components/feature/MangaCard';
import { getMangaByCategory } from '@/mocks/manga';

export default function FeatureZone() {
  const koreanRomance = getMangaByCategory('korean-romance').slice(0, 4);

  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-vip-crown-line"></i>
            </div>
            特色专区
          </div>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
            韩国恋爱漫画精选
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            最受欢迎的<strong>无删减韩国漫画</strong>，甜蜜剧情与细腻画风完美呈现
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 mb-8" data-product-shop="">
          {koreanRomance.map((manga) => (
            <MangaCard key={manga.id} manga={manga} />
          ))}
        </div>

        <div className="text-center">
          <Link
            to="/category/korean-romance"
            className="inline-flex items-center gap-2 px-8 py-3 text-sm font-semibold rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-all"
          >
            查看全部韩国恋爱漫画
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}